import React from 'react';

// Circular affordance signaling a tappable row/card. See design-handoff.md B.1.

const Chevron: React.FC<{ size?: number }> = ({ size = 28 }) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: size,
      height: size,
      borderRadius: 999,
      background: '#e7f1ec',
      color: '#157a55',
      flexShrink: 0,
    }}
    aria-hidden
  >
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path d="M4 2 L8 6 L4 10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </span>
);

export default Chevron;
